import styled from 'styled-components';
import { Box } from '@mui/material';

export const TransparencyPageContainer = styled(Box)`
  min-height: 100vh;
  background: linear-gradient(180deg, #f8fafc 0%, #ffffff 100%);
`;

export const TransparencyPageHeader = styled(Box)`
  background: linear-gradient(135deg, #1e3a5f 0%, #2d5a87 100%);
  color: white;
  padding: 48px 24px;
  text-align: center;
`;

export const TransparencyPageContent = styled(Box)`
  padding: 32px 16px;
`;

export const SectionTitle = styled.h2`
  font-size: 1.5rem;
  font-weight: 600;
  color: #1e293b;
  margin-bottom: 16px;
`;

export const TrendBadge = styled(Box)`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 8px 16px;
  background: ${props => props.positive ? '#e8f5e9' : '#fff3e0'};
  color: ${props => props.positive ? '#2e7d32' : '#ef6c00'};
  border-radius: 20px;
  font-weight: 500;
  font-size: 0.875rem;
`;
